export const FORMA_PAGO_OPCIONES = [
    { value: '10', label: 'Efectivo' },
    { value: '42', label: 'Consignación' },
    { value: '31', label: 'Transferencia' },
    { value: '20', label: 'Cheque' },
    { value: '48', label: 'Tarjeta de crédito' },
    { value: '49', label: 'Tarjeta de débito' },
    { value: 'ZZZ', label: 'Otros' },
];

export const FORMA_PAGO_MAP = {
    '10': 'Efectivo',
    '42': 'Consignación',
    '31': 'Transferencia',
    '20': 'Cheque',
    '48': 'Tarjeta de crédito',
    '49': 'Tarjeta de débito',
    ZZZ: 'Otros',
    '1': 'Otros',
    '30': 'Transferencia',
    '45': 'Transferencia',
    '47': 'Transferencia',
};

export function getFormaPagoTexto(formaPago) {
    if (formaPago === null || formaPago === undefined || formaPago === '') return 'N/A';
    const key = String(formaPago).trim();
    return FORMA_PAGO_MAP[key] || formaPago;
}
